<div class="popup" *ngIf="isVisibleDetails">
    <div class="container-detalles panelDetailLocations" [ngClass]="{'expandir': (fullScreen && !mobileQuery.matches)}">
      <loading [isLoading]="isLoading"></loading>
  
      <div *ngIf="!mobileQuery.matches" class="btnClose">
        <mat-icon class="close-button" matTooltip="Cerrar" aria-hidden="false" aria-label="Example home icon" fontIcon="cancel" (click)="CancelButton()"></mat-icon>
      </div>

      <div *ngIf="!mobileQuery.matches" class="arrow-container">
          <mat-icon *ngIf="!fullScreen" (click)="fullScreen = !fullScreen" class="mobile-flecha">keyboard_arrow_up</mat-icon>
          <mat-icon *ngIf="fullScreen" (click)="fullScreen = !fullScreen" class="mobile-flecha">keyboard_arrow_down</mat-icon>
      </div>
      <div class="details-flex car-details-flex">
  
        <!-- Primera sección -->
        <div class="header_panel">
  
  
            <!-- Botón regresar-->
            <a class="btnReturn" (click)="CancelButton()" matTooltip="Regresar"><mat-icon>arrow_back_ios</mat-icon></a>
  
            <!-- Encabezado -->
            <div *ngIf="images.length == 0" class="header-background" [ngClass]="{'col-3': !mobileQuery.matches}">
                <img [src]="locationDTO.panelIcon | findUrl" class="img-car" />
            </div>

            <!-- carrusel -->
            <div *ngIf="images.length > 0 && mobileQuery.matches" class="header-carousel" [ngClass]="{'col-3': !mobileQuery.matches}">
              <carousel [images]="images"></carousel>
            </div>
  
            <!-- VIN-->
            <div class="row header-text" [ngClass]="{'col-9': !mobileQuery.matches}">
                <label *ngIf="!mobileQuery.matches" class="header-text-label">Id</label>
                <label class="titlePanel vin-title"> 
                  {{ this.locationDTO.identifier }}
                  <div class="copy-to-clipboard" (click)="copyToClipboard(locationDTO.identifier)">
                    <mat-icon>content_copy</mat-icon>
                  </div>
                </label>
                
                <label *ngIf="!mobileQuery.matches" class="header-text-label">Descripción</label>
                <label class="subtitlePanel"> {{this.locationDTO.description}}</label>
            </div>
  
            <!-- Kilometraje -->
            <div *ngIf="mobileQuery.matches" class="header-input">
              <div class="row">
                <div class="col-4 d-flex align-items-center">
                  <label class="" style="font-size: small;">Kilometraje:</label>
                </div>
                <div class="col-8 d-flex align-items-center">
                  <div class="editable">
                    <input type="text" #inputKilometraje [value]="odometroFinalLocation" [readOnly]="readOdometro" [disabled]="readOdometro" 
                    (input)="validarInputOdometro(inputKilometraje)"> Km
                    <mat-icon *ngIf="readOdometro && ('EditarOdometro-L' | permissionFilter)" (click)="cambiarReadOnlyOdometro(inputKilometraje)">edit</mat-icon>
                    <mat-icon [ngClass]="{'display-none': readOdometro}" (click)="UpdateInitialOdometer(inputKilometraje)">done</mat-icon>
                    <mat-icon [ngClass]="{'display-none': readOdometro}" (click)="cambiarReadOnlyOdometro(inputKilometraje)">cancel</mat-icon>
                  </div>
                </div>
              </div>
            </div>

            <!-- Alias -->
            <div *ngIf="mobileQuery.matches && ('EditarAlias-L' | permissionFilter)" class="header-input">
              <div class="row">
                <div class="col-3 d-flex align-items-center">
                  <label class="">Alias:</label>
                </div>
                <div class="col-8 d-flex align-items-center">
                  <div class="editable">
                    <input type="text" [(ngModel)]="locationDTO.alias" [readOnly]="isReadAlias" [disabled]="isReadAlias">
                    <mat-icon *ngIf="isReadAlias" (click)="isReadAlias = false">edit</mat-icon>
                    <mat-icon [ngClass]="{'display-none': isReadAlias}" (click)="submitAlias()">done</mat-icon>
                    <mat-icon [ngClass]="{'display-none': isReadAlias}" (click)="isReadAlias = true">cancel</mat-icon>
                  </div>
                </div>
              </div>
            </div>
  
        </div>
        <!-- seccion de herramientas -->
        <div class="button-tool-list">
          <div class="col-10">
            <location-button-toolbar *ngIf="!isLoading" 
                                      [identifier]="locationDTO.identifier" 
                                      [isDetailLocations]="true" 
                                      [hasValetParking] = "true"
                                      [isValetParking]="valetParkingService.existValetParking" 
                                      [blockingObject]="blockingObject" 
                                      [valetParkingGuid]="valetParkingGuid" 
                                      [isLoadingParent]="isLoading"
                                      [isMonitor]="mobileQuery.matches"
                                      [images]="images"
                                      [isReloadable]="true"
                                      [CordX]="locationDTO.cordsX"
                                      [CordY]="locationDTO.cordsY"
                                      (valetParkingDeleteResponse)="DeleteValetParking($event)"
                                      (valetParkingCreateResponse)="CreateValetParking()"></location-button-toolbar>
          </div>
      
          <div class="col-2">
            <app-report-list [identifier]="locationDTO.identifier" 
                               [isDetailLocations]="true"></app-report-list>
            <!-- <div class="tool-option" > </div> -->
          </div>
        </div>
        <!-- seccion de ttabs -->
        <div class="tab-group">
          <mat-tab-group [(selectedIndex)]="selectedTabIndex" (selectedTabChange)="selectTab($event)" class="details-tab-group">
            <mat-tab>
              <ng-template mat-tab-label >
                <label  matTooltip="Resumen del Activo" matTooltipPosition="above">
                <mat-icon class="example-tab-icon">info</mat-icon>
                 Detalle Activo </label>
              </ng-template>
              <ng-template matTabContent >
                <div class="tab-content-wrapper">
                  <!-- primera sección -->
                  <div [ngClass]="{'container': mobileQuery.matches}">
                    <div class="row text-header">
                      <div class="section-header-background">
                        <h3>Datos Generales</h3>
                      </div>
                    </div>
                    <!-- datos generales de carros -->
                      <div class="row row-data background-shade">
                        <div class="col-4 d-flex align-items-center">
                          <label class="header_panel titlePanel">Estado de Actualización:</label>
                        </div>
                        <div class="col-8 d-flex align-items-center">
                          <div class="general-data bold">{{ this.locationDTO.categoryStatus }}</div>
                        </div>
                      </div>

                      <div class="row row-data row-lastUpdate">
                        <div class="col-4 d-flex align-items-center bold">
                          <label class="header_panel titlePanel">Estado del Vehiculo</label>
                        </div>
                        <div class="col-8 d-flex align-items-center">
                          <div class="general-data bold">{{ this.locationDTO.statusVehiculo }}</div>
                        </div>
                      </div>

                      <div class="row row-data row-lastUpdate background-shade">
                        <div class="col-4 d-flex align-items-center">
                          <label class="titlePanel">Ult. Act:</label>
                        </div>
                        <div class="col-8 general-data bold d-flex align-items-center">
                          <span > {{ this.locationDTO.lastUpdate }}</span>
                        </div>
                      </div>
                      
                      <div class="row row-data">
                        <div class="col-4 d-flex align-items-center">
                          <label class="header_panel titlePanel">Coordenadas</label>
                        </div>
                        <div class="col-8 d-flex align-items-center">
                          <div class="general-data">{{ this.Coords }}</div>
                        </div>
                      </div>
      
                      <div class="row row-data background-shade">
                        <div class="col-4 d-flex align-items-center">
                          <label class="header_panel titlePanel">Bloqueo</label>
                        </div>
                        <div class="col-8 d-flex align-items-center">
                          <div class="general-data">{{ this.locationDTO.canLock }}</div>
                        </div>
                      </div>
      
                      <div class="row row-data" *ngIf="!!this.locationDTO.subGroup">
                        <div class="col-4 d-flex align-items-center">
                          <label class="header_panel titlePanel">Subcuenta</label>
                        </div>
                        <div class="col-8 d-flex align-items-center">
                          <div class="general-data">{{ this.locationDTO.subGroup.name }}</div>
                        </div>
                      </div>
      
                      <div class="row row-data background-shade">
                        <div class="col-4 d-flex align-items-center">
                          <label class="header_panel titlePanel">Dirección</label>
                        </div>
                        <div class="col-8 d-flex align-items-center">
                          <div class="general-data">{{ this.Address }}</div>
                        </div>
                      </div>
                    
                  </div>
                    
    
                  <!-- Tercera sección datos del activo-->
                  <div [ngClass]="{'container': mobileQuery.matches}">
                    <div class="row text-header">
                      <div class="section-header-background">
                        <h3>Datos del Activo</h3>
                      </div>
                    </div>
    
                    <div *ngFor="let key of detallesActivo; let i = index" >
                      <div *ngIf="getNameVisibility(key)" class="row row-data" [ngClass]="{'background-shade': (i % 2 == 0)}">
                        <div class="col-4 d-flex align-items-center">
                          <label class="header_panel titlePanel">{{ getUsableName(key) }}</label>
                        </div>
                        <div class="col-8 d-flex align-items-center general-data">
                          <div>{{ Values[Keys.indexOf(key)] }}</div>
                        </div>
                      </div>  
                    </div>
    
                  </div>
    
                  <!-- Cuarta sección -->
                  <div [ngClass]="{'container': mobileQuery.matches}" class="lastSection">
                    <div class="row text-header">
                      <div class="section-header-background">
                        <h3>Datos del GPS</h3>
                      </div>
                    </div>
            
                    <div *ngIf="getNameVisibility('StatusGPS')" class="row row-data background-shade">
                      <div class="col-4 d-flex align-items-center">
                        <label class="header_panel titlePanel">{{ getUsableName('StatusGPS') }}</label>
                      </div>
                      <div class="col-8 d-flex align-items-center general-data">
                        <div>{{ locationDTO.gpsStatus }}</div>
                      </div>
                    </div>
            
                    <div *ngFor="let key of detallesGPS; let i = index" >
                      <div *ngIf="getNameVisibility(key)" class="row row-data" [ngClass]="{'background-shade': (i % 2 != 0)}">
                        <div class="col-4 d-flex align-items-center">
                          <label class="header_panel titlePanel">{{ getUsableName(key) }}</label>
                        </div>
                        <div class="col-8 d-flex align-items-center general-data">
                          <div>{{ Values[Keys.indexOf(key)] }}</div>
                        </div>
                      </div>
                    </div>
                    <div class="row row-data">
                      <div class="col-4 d-flex align-items-center">
                        <label class="header_panel titlePanel">Voltaje De Bateria</label>
                      </div>
                      <div class="col-8 d-flex align-items-center">
                        <div class="general-data">{{ this.locationDTO.lastVoltaje }}V</div>
                      </div>
                    </div>
                    <div class="row row-data background-shade">
                      <div class="col-4 d-flex align-items-center">
                        <label class="header_panel titlePanel">Porcentaje De Bateria</label>
                      </div>
                      <div class="col-8 d-flex align-items-center">
                        <div class="general-data">{{ this.locationDTO.batteryPercent }}%</div>
                      </div>
                    </div>
                    
                  </div>
                </div>
              </ng-template>
            </mat-tab>

            <mat-tab *ngIf="hasRelatedData" [disabled]="this.isLoading" class="related">
              <ng-template mat-tab-label >
                <label  matTooltip="Activos Asociados" matTooltipPosition="above">
                <mat-icon class="example-tab-icon">info</mat-icon>
                Asociados </label>
              </ng-template>
              <ng-template matTabContent>
                <div class="tab-content-wrapper">
                  <div class="location-related" [ngClass]="{'container': mobileQuery.matches}">
                    <!-- primera seccion -->
                    <!-- servicios asociados -->
                    <location-related-list [identifier]="this.locationDTO.identifier" *ngIf="this.selectedTabIndex == 1"></location-related-list>
                  </div>
                </div>
                  
              </ng-template>
            </mat-tab>
            
          </mat-tab-group>
        </div>
      </div>  
  
    </div>
  </div>